import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "./firebase/config";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Features from "./components/Features";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import WelcomeKit from "./components/WelcomeKit";
import PasswordGate from "./components/PasswordGate";
import AdminLogin from "./components/AdminLogin";
import AdminDashboard from "./components/AdminDashboard";
import PdfTest from "./components/PdfTest";
import "./App.css";

function AppContent() {
    const location = useLocation();
    const hideHeader = location.pathname === "/welcome-kit" || location.pathname === "/password" || location.pathname === "/admin";
    const hideFooter = location.pathname === "/password" || location.pathname === "/admin";

    const AccessGuard = ({ children }) => {
        try {
            const granted = localStorage.getItem("stamp_access_granted");
            if (granted === "1") return children;
        } catch {}
        return (
            <Navigate
                to="/password"
                replace
            />
        );
    };

    const AdminGuard = ({ children }) => {
        try {
            const adminAuth = localStorage.getItem("admin_authenticated");
            const adminEmail = localStorage.getItem("admin_email");
            if (adminAuth === "true" && adminEmail) return children;
        } catch {}
        return <AdminLogin onLogin={() => window.location.reload()} />;
    };

    return (
        <div className="App">
            {!hideHeader && <Header />}
            <Routes>
                <Route
                    path="/"
                    element={
                        <AccessGuard>
                            <>
                                <Hero />
                                <Features />
                                <ContactForm />
                            </>
                        </AccessGuard>
                    }
                />
                <Route
                    path="/welcome-kit"
                    element={<WelcomeKit />}
                />
                <Route
                    path="/password"
                    element={<PasswordGate />}
                />
                <Route
                    path="/password.html"
                    element={
                        <Navigate
                            to="/password"
                            replace
                        />
                    }
                />
                <Route
                    path="/pdf-test"
                    element={<PdfTest />}
                />
                <Route
                    path="/admin"
                    element={
                        <AdminGuard>
                            <AdminDashboard
                                onLogout={() => {
                                    signOut(auth).catch(() => {});
                                    localStorage.removeItem("admin_authenticated");
                                    localStorage.removeItem("admin_email");
                                    window.location.href = "/";
                                }}
                            />
                        </AdminGuard>
                    }
                />
            </Routes>
            {!hideFooter && <Footer />}
        </div>
    );
}

function App() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

export default App;
